export const subscriptionsRoute = '/subscriptions';
export const subscriptionRoute = `${subscriptionsRoute}/:subscriptionId`;
